<div class="ag-shr-report-pdf-actions no-print">
  <dx-button
    text="Download PDF"
    icon="download"
    type="default"
    stylingMode="contained"
    hint="Save the report as a PDF file"
    [height]="height"
    [disabled]="isUnavailable"
    (onClick)="download()"
  ></dx-button>
  <dx-button
    text="Print"
    icon="print"
    type="normal"
    stylingMode="outlined"
    hint="Print the report"
    [height]="height"
    [disabled]="isUnavailable"
    (onClick)="print()"
  ></dx-button>
</div>
